export default {
  NomeExibicao: {
    label: 'fields.module-information.display-name',
  },
  Endereco: {
    label: 'fields.module-information.address',
  },
};
